import { render } from "./CustomerEmail.vue?vue&type=template&id=1a9c29f3"
import script from "./CustomerEmail.vue?vue&type=script&lang=js"
export * from "./CustomerEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__